import apiClient from '@/services/api/apiClient';

export type EngagementStatus = {
  opened: boolean;
  clicked: boolean;
  filled: boolean;
  submitted: boolean;
  downloaded: boolean;
  liked: boolean;
};

export interface EngagementRow {
  deliveryId: string;
  contact: {
    id: string;
    firstName: string;
    lastName: string;
    email: string | null;
    title: string | null;
    engagementScore: number;
    status: 'COLD' | 'ENGAGED' | 'ACTIVE';
    currentStage: string | null;
    account: { id: string; name: string } | null;
  };
  magnet: { id: string; title: string; magnetType: string | null; contentType: string | null };
  status: EngagementStatus;
  timestamps: Record<string, string | null>;
  eventCount: number;
  deliveryStatus: string;
}

export interface TrackingEventRow {
  id: string;
  eventType: string;
  eventData: any;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  contact?: { id: string; firstName: string; lastName: string; email: string | null };
  magnetDelivery?: { id: string; magnet?: { id: string; title: string } };
}

export interface PortalSummary {
  eventsByType: { event: string; count: number }[];
  topMagnets: {
    magnet: { id: string; title?: string; magnetType?: string };
    contactsReached: number;
    totalEvents: number;
  }[];
}

export interface ProvisionResult {
  magnet: { id: string; title: string; subsitePageSlug: string | null; subsiteUrl: string | null };
  webhookSecret: string;
  endpoint: string;
  note: string;
}

// ── Read APIs ────────────────────────────────────────────────────────────────
export const getSummary = async () => {
  const { data } = await apiClient.get<PortalSummary>('/api/magnet-portal/summary');
  return data;
};

export const getEngagement = async (params: {
  magnetId?: string; contactId?: string; accountId?: string; take?: number; skip?: number;
} = {}) => {
  const { data } = await apiClient.get('/api/magnet-portal/engagement', { params });
  return data as { data: EngagementRow[]; total: number; take: number; skip: number };
};

export const getEvents = async (params: { contactId?: string; magnetDeliveryId?: string; take?: number } = {}) => {
  const { data } = await apiClient.get('/api/magnet-portal/events', { params });
  return data as { data: TrackingEventRow[] };
};

// ── Provisioning (Admin / ABM Manager) ────────────────────────────────────────
export const provisionMagnet = async (magnetId: string, body: { slug?: string; url?: string } = {}) => {
  const { data } = await apiClient.post<ProvisionResult>(`/api/magnet-portal/magnets/${magnetId}/provision`, body);
  return data;
};
